import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mapIcon: [],
  mapIcons: [],
  allMapIcons: []
};

export const MapIconsSlice = createSlice({
  name: "mapIcons",
  initialState,
  reducers: {
    getMapIconsAction: (state, action) => {
      state.allMapIcons = action.payload;
    },
    singleMapIconsAction: (state, action) => {
      state.mapIcon = action.payload
    }
  },
});

export default MapIconsSlice.reducer;

export const { getMapIconsAction, singleMapIconsAction } = MapIconsSlice.actions;
